import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/css/index.css";
// After index.css so these beat Bulma's own .notification class.
import "react-notifications/lib/notifications.css";
import "./styles/css/notification-overrides.css";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { enableFourDigitYearDateInputs } from "./common-utilities/globalUiBehaviors";

enableFourDigitYearDateInputs();

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <App style={{ minHeight: "100%" }} />
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
